(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if(!customElements.get('drawer-suggestions'))customElements.define('drawer-suggestions',class extends HTMLElement{
 connectedCallback(){
  const track=this.querySelector('.drawer-suggestion-track'),prev=this.querySelector('[data-suggest-prev]'),next=this.querySelector('[data-suggest-next]');
  if(!track)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  let startX=0,startY=0,moved=false;
  track.addEventListener('touchstart',e=>{const touch=e.touches[0];startX=touch.clientX;startY=touch.clientY;moved=false;},{passive:true,signal});
  track.addEventListener('touchmove',e=>{const touch=e.touches[0];if(Math.abs(touch.clientX-startX)>8||Math.abs(touch.clientY-startY)>8)moved=true;},{passive:true,signal});
  track.addEventListener('click',e=>{if(moved&&e.detail!==0){e.preventDefault();e.stopPropagation();moved=false;}},{capture:true,signal});
  const rtl=getComputedStyle(track).direction==='rtl';
  const update=()=>{prev.disabled=Math.abs(track.scrollLeft)<2;next.disabled=Math.abs(track.scrollLeft)>=track.scrollWidth-track.clientWidth-2;};
  const move=direction=>{const card=track.firstElementChild;if(!card)return;track.scrollBy({left:direction*(rtl?-1:1)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
  prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});
  track.addEventListener('scroll',update,{passive:true,signal});
  track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move((e.key==='ArrowRight'?1:-1)*(rtl?-1:1));}},{signal});
  this.observer=new ResizeObserver(update);this.observer.observe(track);update();
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});

(() => {
if(window.storeDrawerBound)return;
window.storeDrawerBound=true;
let busy=false,opener=null;
const drawer=()=>document.getElementById('store-cart-drawer');
const status=(d,message)=>{d.querySelector('.drawer-status').textContent=message;};
const open=(d,trigger)=>{if(!d.open){opener=trigger||document.activeElement;d.showModal();d.querySelector('[data-drawer-close]').focus();}};
const lock=(d,on)=>{busy=on;d.setAttribute('aria-busy',String(on));d.querySelectorAll('[data-quantity], [name=checkout]').forEach(b=>b.disabled=on);};
const refresh=async(d)=>{
const url=new URL(d.dataset.cartUrl,location.origin);url.searchParams.set('section_id',d.dataset.section);
const response=await fetch(url,{cache:'no-store'});
if(!response.ok)throw Error(d.dataset.error);
const html=new DOMParser().parseFromString(await response.text(),'text/html');
const content=html.querySelector('.drawer-content');if(!content)throw Error(d.dataset.error);
d.querySelector('.drawer-content').replaceWith(content);
document.querySelectorAll('.header-cart-count').forEach(el=>el.textContent=content.dataset.count);
document.querySelectorAll('.header-cart').forEach(el=>el.setAttribute('aria-label',d.dataset.bagLabel+' ('+content.dataset.count+')'));
document.querySelectorAll('.mobile-bag').forEach(el=>el.textContent=d.dataset.bagLabel+' ('+content.dataset.count+')');
document.dispatchEvent(new CustomEvent('offseal:cart:updated'));
};
document.addEventListener('close',e=>{if(e.target.id==='store-cart-drawer'&&opener?.isConnected)opener.focus({preventScroll:true});},true);
document.addEventListener('click',async e=>{
const d=drawer();if(!d)return;
if(e.target.closest('[data-drawer-close]')){d.close();return;}
if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom){d.close();return;}}
const link=e.target.closest('a');
if(link&&!link.hasAttribute('data-cart-fallback')&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&new URL(link.href).pathname===d.dataset.cartUrl){
e.preventDefault();open(d,link);if(busy)return;lock(d,true);status(d,d.dataset.loading);
try{await refresh(d);status(d,'');}catch{status(d,d.dataset.error);}finally{lock(d,false);}return;
}
const button=e.target.closest('[data-quantity]');if(!button||!d.contains(button)||busy)return;
const row=button.closest('[data-key]'),key=row.dataset.key,quantity=Math.max(0,Number(button.dataset.quantity));
const payload={id:key,quantity};
if(row.dataset.productHandle==='night-reflective-hooded-jacket'&&quantity>0){
const properties=JSON.parse(row.dataset.properties||'{}')||{};
payload.properties=Array.isArray(properties)?Object.fromEntries(properties):properties;
payload.properties.__stack_bundle=quantity===2?'p:20@2:'+row.dataset.bundleLabel:quantity===3?'p:35@3:'+row.dataset.bundleLabel:'';
}
lock(d,true);status(d,d.dataset.loading);
try{const response=await fetch(d.dataset.root.replace(/\/?$/, '/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});const data=await response.json().catch(()=>{throw Error(d.dataset.error);});if(!response.ok)throw Error(data.description||data.message||d.dataset.error);await refresh(d);status(d,d.dataset.updated);d.querySelector('[data-drawer-close]').focus();}
catch(error){status(d,error.message||d.dataset.error);}finally{lock(d,false);}
});
document.addEventListener('stack:cart:open',async ()=>{
const d=drawer();if(!d||busy)return;open(d);lock(d,true);status(d,d.dataset.loading);
try{await refresh(d);status(d,d.dataset.added);}catch{status(d,d.dataset.error);}finally{lock(d,false);}
});
document.addEventListener('submit',async e=>{
const form=e.target,d=drawer();if(!d||!form.matches('.pdp-form'))return;
e.preventDefault();if(busy)return;
const submit=form.querySelector('[type=submit]');if(submit.disabled)return;
const payload=new FormData(form);submit.disabled=true;open(d,submit);lock(d,true);status(d,d.dataset.loading);
try{const response=await fetch(d.dataset.root.replace(/\/?$/, '/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:payload});const data=await response.json().catch(()=>{throw Error(d.dataset.error);});if(!response.ok)throw Error(data.description||data.message||d.dataset.error);await refresh(d);status(d,d.dataset.added);}
catch(error){status(d,error.message||d.dataset.error);}finally{lock(d,false);if(submit.isConnected)submit.disabled=false;}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-jacket"] && !Shopify.designMode) return;
  try {
    
(()=>{
const mobile=matchMedia('(max-width:760px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
function init(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const films=[...root.querySelectorAll('.cinema-film')],buttons=[...root.querySelectorAll('[data-film-index]')],range=root.querySelector('.cinema-range'),stage=root.querySelector('.cinema-stage'),status=root.querySelector('.cinema-status'),label=root.querySelector('.cinema-colour-name');
if(!films.length)return;
let current=0,progress=0,visible=false,drag=null,failed=false;
let words;try{words=JSON.parse(root.dataset.chapters||'[]')}catch{words=[]}
const still=()=>reduced.matches||document.documentElement.dataset.themeMotion==='off';
const active=()=>films[current];
const update=()=>{range.value=Math.round(progress*1000);const w=words[Math.min(words.length-1,Math.floor(progress*words.length))];if(w){root.querySelector('.cinema-index').textContent=w[0];root.querySelector('.cinema-title').textContent=w[1];}};
const release=v=>{v.pause();if(v.getAttribute('src')){v.removeAttribute('src');v.load();}v.classList.remove('is-playing');};
const play=()=>{const v=active();if(!visible||still()||document.hidden||failed||!v.getAttribute('src'))return;v.play().then(()=>{if(v!==active()||!visible||still()||document.hidden)v.pause();}).catch(()=>{if(v===active())status.textContent=root.dataset.still||'Explore the jacket below.';});};
const load=()=>{const v=active();if(still()||!visible||failed)return;const src=mobile.matches?v.dataset.mobileSrc:v.dataset.src;if(!src){status.textContent=root.dataset.still||'Explore the jacket below.';return;}if(v.getAttribute('src')!==src){status.textContent=root.dataset.loading||'Loading motion…';v.src=src;v.load();}else play();};
const choose=i=>{films.forEach(release);current=i;failed=false;progress=0;films.forEach((v,j)=>{v.classList.toggle('active',i===j);v.setAttribute('aria-hidden',String(i!==j));v.removeAttribute('poster');});buttons.forEach((b,j)=>b.setAttribute('aria-pressed',String(i===j)));const v=active();v.poster=(mobile.matches?v.dataset.mobilePoster:v.dataset.poster)||v.dataset.poster||'';root.style.setProperty('--cinema-backdrop','url("'+v.poster+'")');label.textContent=buttons[i]?.getAttribute('aria-label')||'';status.textContent='';range.disabled=still();update();load();};
const seek=p=>{if(still())return;progress=Math.max(0,Math.min(1,p));const v=active();if(v.readyState>=2&&Number.isFinite(v.duration))v.currentTime=progress*Math.max(0,v.duration-.1);update();};
films.forEach(v=>{v.muted=true;v.playsInline=true;v.loop=true;v.addEventListener('loadeddata',()=>{if(v===active()){status.textContent='';play();}});v.addEventListener('timeupdate',()=>{if(v===active()&&!drag){progress=v.currentTime/(v.duration||1);update();}});v.addEventListener('error',()=>{if(v!==active()||!v.getAttribute('src'))return;failed=true;release(v);status.textContent=root.dataset.error||'Motion unavailable. Explore the jacket below.';});});
buttons.forEach((b,i)=>b.addEventListener('click',()=>choose(i)));
range.addEventListener('input',()=>seek(Number(range.value)/1000));
stage.addEventListener('pointerdown',e=>{if(still())return;drag={x:e.clientX,y:e.clientY,p:progress,locked:false};});
stage.addEventListener('pointermove',e=>{if(!drag)return;const dx=e.clientX-drag.x,dy=e.clientY-drag.y;if(!drag.locked&&Math.abs(dy)>Math.abs(dx)+6){drag=null;return;}if(!drag.locked&&Math.abs(dx)>10){drag.locked=true;stage.setPointerCapture(e.pointerId);active().pause();}if(drag.locked)seek(drag.p+dx/stage.clientWidth);});
const end=()=>{drag=null;play();};stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);
stage.addEventListener('keydown',e=>{if(['ArrowRight','ArrowLeft','Home','End'].includes(e.key)){e.preventDefault();seek(e.key==='Home'?0:e.key==='End'?1:progress+(e.key==='ArrowRight'?.05:-.05));}});
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)load();else active().pause();},{threshold:.05});observer.observe(root);
document.addEventListener('visibilitychange',()=>{if(document.hidden)active().pause();else play();});
const adapt=()=>choose(current);mobile.addEventListener('change',adapt);reduced.addEventListener('change',adapt);
root.addEventListener('shopify:section:unload',()=>{observer.disconnect();films.forEach(release);mobile.removeEventListener('change',adapt);reduced.removeEventListener('change',adapt);});
choose(0);
}
document.querySelectorAll('.cinema').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.cinema').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-catalog"]) return;
  try {
    
document.querySelectorAll('.oc-catalog').forEach(catalog=>{
  const categories=catalog.querySelector('.oc-categories');
  if(window.matchMedia('(max-width:749px)').matches) categories.removeAttribute('open');
  const form=catalog.querySelector('.oc-sort');
  form.querySelector('select').addEventListener('change',()=>form.requestSubmit());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.collection-track');
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      if (!track || !previous || !next) return;
      const cards = Array.from(track.querySelectorAll('.shop-card'));
      const rtl = getComputedStyle(track).direction === 'rtl';
      const update = () => {
        const position = Math.abs(track.scrollLeft);
        const maximum = track.scrollWidth - track.clientWidth;
        previous.disabled = position < 2;
        next.disabled = position >= maximum - 2;
      };
      const move = (direction) => {
        const step = cards.length > 1 ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) : track.clientWidth;
        track.scrollBy({left: direction * step * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      const back = () => move(-1);
      const forward = () => move(1);
      const keyboard = (event) => {
        if (event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth * (rtl ? -1 : 1)});
        else move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      };
      previous.addEventListener('click', back);
      next.addEventListener('click', forward);
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', keyboard);
      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();
      this.cleanup = () => {
        observer.disconnect();
        previous.removeEventListener('click', back);
        next.removeEventListener('click', forward);
        track.removeEventListener('scroll', update);
        track.removeEventListener('keydown', keyboard);
      };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-lab"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope){const roots=scope.matches?.('.design-lab')?[scope]:[...scope.querySelectorAll('.design-lab')];roots.forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const buttons=[...root.querySelectorAll('[data-lab]')],layers=[...root.querySelectorAll('[data-layer]')],panel=root.querySelector('.lab-visual');function select(i){if(!buttons[i])return;buttons.forEach((b,j)=>{b.setAttribute('aria-selected',String(i===j));b.tabIndex=i===j?0:-1;});layers.forEach((layer,j)=>layer.hidden=i!==j);root.dataset.detail=i;panel.setAttribute('aria-labelledby',buttons[i].id);root.querySelector('.lab-caption span').textContent=buttons[i].querySelector('span').textContent;root.querySelector('.lab-caption p').textContent=buttons[i].dataset.copy;}buttons.forEach((b,i)=>{b.addEventListener('click',()=>select(i));b.addEventListener('keydown',e=>{if(['ArrowDown','ArrowRight','ArrowUp','ArrowLeft','Home','End'].includes(e.key)){e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?buttons.length-1:(i+(['ArrowDown','ArrowRight'].includes(e.key)?1:-1)+buttons.length)%buttons.length;select(next);buttons[next].focus();}});});root.addEventListener('shopify:block:select',e=>{const i=buttons.findIndex(b=>b.dataset.blockId===e.detail.blockId);select(i);});select(0);});}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-bestsellers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async event=>{const button=event.target.closest('[data-fit-featured]');if(!button)return;const builder=document.querySelector('offseal-fit');if(!builder)return;await customElements.whenDefined('offseal-fit');builder.addFeatured(button.dataset.fitFeatured)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-builder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('offseal-fit'))customElements.define('offseal-fit',class extends HTMLElement{
connectedCallback(){if(this.booted)return;this.booted=true;this.visibilityObserver=new IntersectionObserver(entries=>{this.dataset.inView=String(entries[0].isIntersecting)},{threshold:0});this.visibilityObserver.observe(this);this.querySelector(".of-review").open=true;this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);this.items=[null,null,null];this.activeSlot=null;this.cache=new Map();this.pages=new Map();this.catalogSequence=0;this.querySelector('[data-more]').addEventListener('click',()=>this.loadCatalog(this.currentPanel));this.querySelector('[data-search-form]').addEventListener('submit',e=>{e.preventDefault();this.searchCatalog()});this.querySelector('[data-search]').addEventListener('input',e=>{if(!e.target.value)this.category(this.querySelector('[data-category]'))});this.browserDialog=this.querySelector('.of-catalog');this.dialog=this.querySelector('.of-dialog');this.money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'});this.addEventListener('click',e=>this.click(e));this.querySelector('[data-review]').addEventListener('click',()=>this.dockAction());this.querySelector('[data-variant]').addEventListener('change',()=>this.variantChanged());this.querySelector('[data-confirm]').addEventListener('click',()=>this.confirm());this.querySelector('[data-submit]').addEventListener('click',()=>this.dockAction());this.querySelector('[data-start]').addEventListener('click',()=>this.dockAction());this.querySelector('[data-shuffle]').addEventListener('click',()=>this.shuffle());this.querySelector('[data-clear]').addEventListener('click',()=>{this.items=[null,null,null];this.activeSlot=null;this.render()});this.querySelector('[role=tablist]').addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const tabs=[...this.querySelectorAll('[role=tab]')],i=tabs.indexOf(document.activeElement),n=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;this.category(tabs[n]);tabs[n].focus()});this.querySelector('[data-back-looks]').addEventListener('click',()=>this.showLooks());this.render()}
disconnectedCallback(){this.visibilityObserver?.disconnect()}
addFeatured(handle){this.showEditor();const free=this.items.findIndex(p=>!p);if(free<0){this.querySelector('[data-error]').textContent=this.copy.full;return}this.activeSlot=free;this.open(handle)}
showEditor(){this.dataset.started='true';const looks=document.querySelector('.of-examples');if(looks)looks.hidden=true;this.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
showLooks(){const looks=document.querySelector('.of-examples');if(!looks)return;this.dataset.started='false';looks.hidden=false;looks.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});looks.querySelector('[data-fit-look]')?.focus({preventScroll:true})}
startCustom(){this.items=[null,null,null];this.render();this.showEditor();this.activeSlot=0;this.showCatalog()}
dockAction(){if(this.submitting)return;const pending=this.items.findIndex(p=>p&&!p.variant);if(pending>=0){this.activeSlot=pending;this.open(this.items[pending].handle);return}if(this.items.filter(Boolean).length<2){this.activeSlot=this.items.findIndex(p=>!p);this.showCatalog();return}this.submit()}
async loadLook(handles){if(this.loadingLook||this.submitting)return;this.loadingLook=true;this.querySelector('[data-error]').textContent=this.copy.loading;try{const products=await Promise.all(handles.slice(0,3).map(h=>{this.cache.delete(h);return this.product(h)}));this.items=[null,null,null];products.forEach((p,i)=>{const v=p.variants.find(v=>v.available)||p.variants[0];this.items[i]={handle:p.handle,title:p.title,productId:p.id,variant:null,variantTitle:this.copy.size_first,price:v.price,image:p.featured_image}});this.activeSlot=null;this.render();this.showEditor();this.querySelector('[data-submit]').focus({preventScroll:true})}catch{this.querySelector('[data-error]').textContent=this.copy.error}finally{this.loadingLook=false}}
openCollection(handle,label){this.showEditor();let panel=[...this.querySelectorAll('[data-panel]')].find(p=>p.dataset.collection===handle);let tab;if(panel){tab=[...this.querySelectorAll('[data-category]')].find(t=>t.dataset.category===panel.dataset.panel)}else{const id='extra-'+handle;tab=this.node('button',label);tab.type='button';tab.setAttribute('role','tab');tab.dataset.category=id;tab.id='FitExtraTab-'+handle;tab.setAttribute('aria-controls','FitExtraPanel-'+handle);this.querySelector('[role=tablist]').append(tab);panel=this.node('div',undefined,'of-products');panel.id='FitExtraPanel-'+handle;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tab.id);panel.dataset.panel=id;panel.dataset.collection=handle;this.querySelector('[data-search-results]').before(panel)}this.activeSlot=null;this.category(tab);if(!this.browserDialog.open)this.browserDialog.showModal();this.browserDialog.scrollTop=0;tab.focus()}
format(v){return this.money.format(v/100)}
node(tag,text,cls){const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n}
category(tab){if(!tab)return;this.catalogSequence++;this.querySelector('[data-search]').value='';this.querySelector('[data-search-results]').hidden=true;this.querySelectorAll('[role=tab]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==tab.dataset.category);this.currentPanel=this.querySelector('[data-panel="'+tab.dataset.category+'"]');this.loadCatalog(this.currentPanel,true)}
showCatalog(){this.category(this.querySelector('[data-category]'));this.browserDialog.showModal();this.browserDialog.scrollTop=0}
searchCatalog(){const term=this.querySelector('[data-search]').value.trim();if(!term){this.category(this.querySelector('[data-category]'));return}this.catalogSequence++;this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=true);this.querySelectorAll('[role=tab]').forEach(t=>t.setAttribute('aria-selected','false'));const panel=this.querySelector('[data-search-results]');panel.hidden=false;panel.replaceChildren();this.pages.delete(panel);panel.dataset.query=term;this.currentPanel=panel;this.loadCatalog(panel)}
async loadCatalog(panel,existing=false){if(!panel)return;let state=this.pages.get(panel);if(!state){const url=new URL(this.dataset.root+(panel.dataset.query?'search':'collections/'+encodeURIComponent(panel.dataset.collection||'all')),location.origin);url.searchParams.set('view','fit-products');if(panel.dataset.query){url.searchParams.set('q',panel.dataset.query);url.searchParams.set('type','product');url.searchParams.set('options[unavailable_products]','show')}state={next:url.href,loaded:false,busy:false,total:0};this.pages.set(panel,state)}const more=this.querySelector('[data-more]'),status=this.querySelector('[data-catalog-status]');if(existing&&state.loaded){this.catalogStatus(panel,state);return}if(state.busy)return;state.busy=true;more.disabled=true;more.hidden=true;status.textContent=this.copy.loading;try{if(state.next){const response=await fetch(state.next);if(!response.ok)throw Error();const doc=new DOMParser().parseFromString(await response.text(),'text/html'),batch=doc.querySelector('[data-fit-batch]');if(!batch)throw Error();if(this.pages.get(panel)!==state)return;const ids=new Set([...panel.querySelectorAll('[data-product-id]')].map(c=>c.dataset.productId));batch.querySelectorAll('.of-product').forEach(c=>{if(!ids.has(c.dataset.productId)){panel.append(document.importNode(c,true));ids.add(c.dataset.productId)}});state.next=batch.dataset.next?new URL(batch.dataset.next,location.origin).href:null;if(state.next){const next=new URL(state.next);next.searchParams.set('view','fit-products');state.next=next.href}state.total=Number(batch.dataset.total);state.loaded=true}if(panel===this.currentPanel&&this.pages.get(panel)===state)this.catalogStatus(panel,state)}catch{if(panel===this.currentPanel&&this.pages.get(panel)===state){status.textContent=this.copy.error;more.hidden=false;more.textContent=this.copy.more}}finally{state.busy=false;if(panel===this.currentPanel&&this.pages.get(panel)===state)more.disabled=false}}
catalogStatus(panel,state){const count=panel.querySelectorAll('[data-product-id]').length;this.querySelector('[data-catalog-status]').textContent=count?this.copy.loaded.replace('{count}',count).replace('{total}',state.total):this.copy.no_results;const more=this.querySelector('[data-more]');more.hidden=!state.next;more.disabled=state.busy;more.textContent=this.copy.more}

click(e){const size=e.target.closest('[data-edit-size]');if(size){this.activeSlot=Number(size.dataset.editSize);this.open(this.items[this.activeSlot].handle);return}const tab=e.target.closest('[data-category]');if(tab)this.category(tab);const pick=e.target.closest('[data-pick]');if(pick){this.activeSlot=Number(pick.dataset.pick);this.showCatalog()}const remove=e.target.closest('[data-remove]');if(remove){this.items[Number(remove.dataset.remove)]=null;this.render()}const change=e.target.closest('[data-change]');if(change){this.activeSlot=Number(change.dataset.change);this.showCatalog()}const choose=e.target.closest('[data-choose]');if(choose){if(this.activeSlot===null&&this.items.every(Boolean)){this.querySelector('[data-error]').textContent=this.copy.full;this.querySelector('.of-board').scrollIntoView({block:'center',behavior:'smooth'});return}this.open(choose.closest('[data-handle]').dataset.handle)}}
async product(handle){if(!this.cache.has(handle)){const response=await fetch(this.dataset.root+'products/'+encodeURIComponent(handle)+'.js');if(!response.ok)throw Error(this.copy.error);this.cache.set(handle,await response.json())}return this.cache.get(handle)}
async open(handle){this.querySelector('[data-error]').textContent='';this.querySelector('[data-modal-title]').textContent=this.copy.loading;this.querySelector('[data-modal-price]').textContent='';this.querySelector('[data-modal-image]').removeAttribute('src');this.querySelector('[data-modal-error]').textContent='';this.querySelector('[data-variant]').replaceChildren();this.querySelector('[data-confirm]').disabled=true;this.querySelector('[data-detail]').removeAttribute('href');this.current=null;const request=Symbol();this.request=request;if(!this.dialog.open)this.dialog.showModal();try{const p=await this.product(handle);if(this.request!==request||!this.dialog.open)return;this.current=p;this.querySelector('[data-modal-title]').textContent=p.title;this.querySelector('[data-confirm]').textContent=this.copy.save_piece;this.querySelector('[data-modal-image]').src=p.featured_image||'';this.querySelector('[data-modal-image]').alt=p.title;this.querySelector('[data-modal-price]').textContent=this.format(p.price);this.querySelector('[data-detail]').href=this.dataset.root+'products/'+p.handle;const select=this.querySelector('[data-variant]');select.append(new Option(this.copy.size_first,''));p.variants.forEach(v=>{const o=new Option(v.title+(v.available?'':' — '+this.copy.sold_out),v.id);o.disabled=!v.available;select.append(o)});const existing=this.items[this.activeSlot]?.variant;if(existing&&p.variants.some(v=>v.id===existing&&v.available)){select.value=existing;this.variantChanged()}if(p.variants.length===1&&p.variants[0].available){select.value=p.variants[0].id;this.variantChanged()}}catch{this.querySelector('[data-modal-error]').textContent=this.copy.error}}
variantChanged(){const v=this.current?.variants.find(v=>String(v.id)===this.querySelector('[data-variant]').value);this.querySelector('[data-confirm]').disabled=!v?.available;if(v){this.querySelector('[data-modal-price]').textContent=this.format(v.price);this.querySelector('[data-modal-image]').src=v.featured_image?.src||this.current.featured_image||''}}
confirm(){const v=this.current?.variants.find(v=>String(v.id)===this.querySelector('[data-variant]').value);if(!v?.available)return;const i=this.activeSlot??this.items.findIndex(x=>!x);if(i<0)return;this.items[i]={handle:this.current.handle,title:this.current.title,productId:this.current.id,variant:v.id,variantTitle:v.title,price:v.price,image:v.featured_image?.src||this.current.featured_image};this.dialog.close();this.browserDialog.close();this.activeSlot=null;this.render();if(!matchMedia('(prefers-reduced-motion: reduce)').matches)this.querySelector('[data-slot="'+i+'"]').animate([{opacity:.3,transform:'translateY(8px) scale(.97)'},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:240,easing:'ease-out'});const pending=this.items.findIndex(p=>p&&!p.variant);if(pending>=0){this.activeSlot=pending;this.open(this.items[pending].handle)}else{this.querySelector('[data-slot="'+i+'"] [data-change]').focus({preventScroll:true})}}
render(){this.querySelectorAll('[data-slot]').forEach((slot,i)=>{slot.replaceChildren();const p=this.items[i];slot.classList.toggle('is-filled',!!p);if(!p){const b=this.node('button',undefined,'of-empty');b.type='button';b.dataset.pick=i;b.append(this.node('span','0'+(i+1),'of-slot-number'),this.node('span','+','of-plus'),this.node('span',i===2?this.copy.optional:this.copy.pick));slot.append(b);return}const img=this.node('img');img.src=p.image;img.alt=p.title;img.width=400;img.height=500;const c=this.node('div',undefined,'of-slot-copy');c.append(this.node('strong',p.title),this.node('span',(p.variantTitle==='Default Title'?'':p.variantTitle+' · ')+this.format(p.price)));const ch=this.node('button',this.copy.change,'of-change');ch.type='button';ch.dataset.change=i;c.append(ch);{const size=this.node('button',p.variant?this.copy.edit_size:this.copy.size_first,'of-size');size.type='button';size.dataset.editSize=i;c.append(size)}const r=this.node('button','×','of-remove');r.type='button';r.dataset.remove=i;r.setAttribute('aria-label',this.copy.remove+' '+p.title);slot.append(img,c,r)});const list=this.items.filter(Boolean),sum=list.reduce((a,p)=>a+p.price,0),usd=this.dataset.currency==='USD',rate=usd&&list.length>=2?(sum>=20000?20:sum>=15000?15:sum>=10000?10:0):0,savings=list.reduce((a,p)=>a+Math.floor(p.price*rate/100),0);this.querySelector('[data-count]').textContent=list.length+' / 3';this.querySelector('[data-dock-count]').textContent=this.copy.pieces.replace('{count}',list.length);this.querySelector('[data-dock-total]').textContent=this.format(sum-savings);this.querySelectorAll('[data-choose]').forEach(b=>{const selected=list.some(p=>p.handle===b.closest('[data-handle]').dataset.handle);b.classList.toggle('is-selected',selected);b.querySelector('.of-add').textContent=selected?'✓':'+'});this.querySelector('[data-subtotal]').textContent=this.format(sum);this.querySelector('[data-saving]').textContent='−'+this.format(savings);this.querySelector('[data-saving-label]').textContent=this.copy.saving_label.replace('{rate}',rate);this.querySelector('[data-total]').textContent=this.format(sum-savings);this.querySelector('[data-progress]').style.width=(usd?Math.min(sum/20000*100,100):0)+'%';const next=[10000,15000,20000].find(x=>x>sum);this.querySelector('[data-hint]').textContent=!usd?this.copy.currency:list.length<2?this.copy.start:next?this.copy.next.replace('{amount}',this.format(next-sum)).replace('{rate}',next===10000?10:next===15000?15:20):this.copy.max;const submit=this.querySelector('[data-submit]');submit.textContent=list.length<2?this.copy.next_piece:this.dataset.ready!=='true'?this.copy.preview_button:this.copy.add_fit;const pending=list.some(p=>!p.variant);submit.disabled=this.dataset.ready!=='true'||!usd;if(pending)submit.textContent=this.copy.choose_sizes;const dock=this.querySelector('[data-review]');dock.textContent=!list.length?this.copy.first_piece:pending?this.copy.choose_sizes:list.length<2?this.copy.next_piece:this.copy.add_fit;dock.disabled=list.length>=2&&!pending&&(this.dataset.ready!=='true'||!usd);this.querySelector('[data-dock-savings]').textContent=savings?this.copy.saved.replace('{amount}',this.format(savings)):'';this.querySelector('[data-error]').textContent='';this.updateExperience(list,sum,rate)}
updateExperience(list,sum,rate){const count=list.length;this.dataset.pieces=count;this.querySelector('[data-clear]').hidden=!count;this.querySelector('[data-start]').hidden=count>0;this.querySelectorAll('[data-step]').forEach((el,i)=>{el.classList.toggle('is-active',i===(count<2?0:list.some(p=>!p.variant)?1:2))});this.querySelectorAll('.of-milestones span').forEach((el,i)=>el.classList.toggle('is-earned',rate>=[10,15,20][i]));if(this.lastRate!==undefined&&rate>this.lastRate){this.querySelector('[data-feedback]').textContent=this.copy.unlocked.replace('{rate}',rate);this.querySelector('.of-rewards').animate([{transform:'scale(1)'},{transform:'scale(1.025)'},{transform:'scale(1)'}],{duration:matchMedia('(prefers-reduced-motion: reduce)').matches?0:400})}else{this.querySelector('[data-feedback]').textContent=''}this.lastRate=rate;this.querySelector('.of-review').hidden=count===0;this.querySelector('.of-dock').classList.toggle('is-empty',!count)}
async shuffle(){this.showEditor();const button=this.querySelector('[data-shuffle]');button.disabled=true;try{const groups=[['tops','knits','tees'],['bottoms','pants'],['extras']],chosen=[];for(const ids of groups){const handles={tops:'hoodies',knits:'sweaters-knitwear',tees:'t-shirts-tops',bottoms:'jeans',pants:'pants',extras:'accessories'},panels=[...this.querySelectorAll('[data-panel]')].filter(p=>ids.some(id=>handles[id]===p.dataset.collection)),panel=panels[Math.floor(Math.random()*panels.length)]||this.querySelector('[data-panel]');if(!panel){chosen.push(null);continue}await this.loadCatalog(panel,true);const cards=[...panel.querySelectorAll('[data-handle]')].filter(c=>!c.querySelector('[data-choose]').disabled&&!chosen.some(p=>p&&String(p.productId)===c.dataset.productId));if(!cards.length){chosen.push(null);continue}const p=await this.product(cards[Math.floor(Math.random()*cards.length)].dataset.handle),v=p.variants.find(v=>v.available);chosen.push(v?{handle:p.handle,title:p.title,productId:p.id,variant:null,variantTitle:this.copy.size_first,price:v.price,image:v.featured_image?.src||p.featured_image}:null)}this.items=chosen;this.activeSlot=null;this.render();this.querySelector('[data-submit]').focus({preventScroll:true})}catch{this.querySelector('[data-error]').textContent=this.copy.error}finally{button.disabled=false}}

async submit(){
if(this.submitting||this.dataset.ready!=='true'||this.dataset.currency!=='USD')return;
const selected=this.items.filter(Boolean);if(selected.length<2||selected.length>3||selected.some(p=>!p.variant))return;
this.submitting=true;this.querySelector('[data-review]').disabled=true;this.querySelector('[data-review]').textContent=this.copy.loading;const button=this.querySelector('[data-submit]');button.disabled=true;button.textContent=this.copy.loading;
try{
// Refresh variant prices and availability before calculating the selected outfit tier.
const fresh=await Promise.all(selected.map(async p=>{const r=await fetch(this.dataset.root+'products/'+encodeURIComponent(p.handle)+'.js');if(!r.ok)throw Error(this.copy.error);const product=await r.json(),v=product.variants.find(v=>v.id===p.variant);if(!v?.available)throw Error(p.title+': '+this.copy.sold_out);return {...p,price:v.price}}));
const sum=fresh.reduce((n,p)=>n+p.price,0),rate=sum>=20000?20:sum>=15000?15:sum>=10000?10:0,code=rate?'OFFSEALFIT'+rate:'';
const signature=JSON.stringify(fresh.map(p=>p.variant));
if(this.addedSignature!==signature){
const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:fresh.map(p=>({id:p.variant,quantity:1,properties:{_offseal_fit:'v2'}}))})});
const data=await response.json();if(!response.ok)throw Error(data.description||this.copy.error);this.addedSignature=signature;
}
const response=await fetch(this.dataset.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code})});
if(!response.ok)throw Error(this.copy.error);
document.dispatchEvent(new CustomEvent('stack:cart:open'));
button.disabled=false;button.textContent=this.copy.add_fit;
}catch(err){this.querySelector('[data-error]').textContent=err.message;button.disabled=false;button.textContent=this.copy.add_fit}finally{this.submitting=false;const dock=this.querySelector('[data-review]');dock.disabled=false;dock.textContent=this.copy.add_fit}
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-catalog"]) return;
  try {
    
(()=>{
 function init(scope=document){scope.querySelectorAll('.fit-catalog').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='true';el.querySelector('.oc-categories').open=matchMedia('(min-width:750px)').matches;});}
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
 if(window.offsealFitCatalogBound)return;window.offsealFitCatalogBound=true;
 async function load(el,url,focus){
  if(el.getAttribute('aria-busy')==='true')return;
  el.setAttribute('aria-busy','true');el.querySelector('[role=status]').textContent='Loading collection…';
  try{
   if(url.pathname.includes('/pages/'))url.pathname=new URL(el.querySelector('.oc-sort').action).pathname;
   url.searchParams.set('view','fit-catalog');const response=await fetch(url);if(!response.ok)throw Error();
   const doc=new DOMParser().parseFromString(await response.text(),'text/html'),next=doc.querySelector('.fit-catalog');if(!next)throw Error();
   el.replaceWith(next);init(next.parentElement);
   const target=next.querySelector(focus);target?.setAttribute('tabindex','-1');target?.focus({preventScroll:true});
   next.querySelector('.oc-layout').scrollIntoView({block:'start',behavior:'instant'});
  }catch{el.querySelector('[role=status]').textContent='Could not load products. Please try again.';el.removeAttribute('aria-busy');}
 }
 document.addEventListener('click',e=>{
  const link=e.target.closest('.fit-catalog .oc-categories a,.fit-catalog .oc-pagination a');
  if(!link||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey||e.button!==0)return;
  e.preventDefault();load(link.closest('.fit-catalog'),new URL(link.href),'.oc-toolbar');
 });
 document.addEventListener('change',e=>{if(e.target.matches('.fit-catalog .oc-sort select'))e.target.form.requestSubmit();});
 document.addEventListener('submit',e=>{if(!e.target.matches('.fit-catalog .oc-sort'))return;e.preventDefault();const url=new URL(e.target.action);url.searchParams.set('sort_by',new FormData(e.target).get('sort_by'));load(e.target.closest('.fit-catalog'),url,'.oc-sort select');});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-examples"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async function(event){const builder=document.querySelector('offseal-fit');if(event.target.closest('[data-fit-custom]')&&builder){await customElements.whenDefined('offseal-fit');builder.startCustom();return}const look=event.target.closest('[data-fit-look]');const story=event.target.closest('[id$="__collection_stories"] a');if(builder&&(look||story)){event.preventDefault();await customElements.whenDefined('offseal-fit');if(look){look.disabled=true;await builder.loadLook(look.dataset.fitLook.split(','));look.disabled=false}else{const url=new URL(story.href,location.href),match=url.pathname.match(/\/collections\/([^/]+)/);if(match)builder.openCollection(decodeURIComponent(match[1]),story.textContent.trim())}return}const link=event.target.closest('[data-fit-examples-start]');if(!link)return;if(!builder)return;event.preventDefault();builder.showEditor();builder.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});const pick=builder.querySelector('[data-pick]');if(pick)pick.focus({preventScroll:true});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frequency"] && !Shopify.designMode) return;
  try {
    
(()=>{const reduce=document.documentElement.dataset.themeMotion==='off'||matchMedia('(prefers-reduced-motion: reduce)').matches;function setup(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const items=[...root.querySelectorAll('.frequency-item')],dots=[...root.querySelectorAll('.frequency-dots button')],stage=root.querySelector('.frequency-stage');if(!items.length)return;let active=0,start=null;function show(n){active=(n+items.length)%items.length;items.forEach((el,i)=>{el.classList.toggle('active',i===active);el.classList.toggle('before',i===(active-1+items.length)%items.length);el.classList.toggle('after',i===(active+1)%items.length);el.setAttribute('aria-hidden',i!==active);});dots.forEach((el,i)=>el.setAttribute('aria-pressed',i===active));const item=items[active];root.style.setProperty('--wash',item.dataset.wash);root.style.setProperty('--accent',item.dataset.accent);root.querySelector('.frequency-word').textContent=item.dataset.word;root.querySelector('.frequency-name').textContent=item.dataset.name;root.querySelector('.frequency-number').textContent=String(active+1).padStart(2,'0')+' / '+String(items.length).padStart(2,'0');root.querySelector('.frequency-shop').href=item.dataset.link||'#jacket';}
root.querySelector('[data-prev]').onclick=()=>show(active-1);root.querySelector('[data-next]').onclick=()=>show(active+1);dots.forEach((b,i)=>b.onclick=()=>show(i));root.querySelector('[data-shuffle]').onclick=()=>show(active+1+Math.floor(Math.random()*Math.max(1,items.length-1)));
stage.onpointerdown=e=>{start=e.clientX;stage.setPointerCapture(e.pointerId);};stage.onpointerup=e=>{if(start!==null&&Math.abs(e.clientX-start)>30)show(active+(e.clientX<start?1:-1));start=null;};stage.onpointercancel=()=>start=null;
root.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1));}});
root.querySelector('.frequency-shop').onclick=e=>{if(root.dataset.local==='true'){const card=document.querySelectorAll('.colour-card')[active];if(card){e.preventDefault();card.click();}}};
new IntersectionObserver(entries=>{root.classList.toggle('frequency-motion',entries[0].isIntersecting&&!reduce);},{threshold:.2}).observe(root);show(0);}
document.querySelectorAll('.frequency').forEach(setup);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.frequency').forEach(setup));
if(!reduce){const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('stage-reveal');observer.unobserve(e.target);}}),{threshold:.15});document.querySelectorAll('.lab-copy,.collection-heading,.frequency-head,.closing h2').forEach(e=>observer.observe(e));}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

(()=>{function init(){const trigger=document.querySelector('.mobile-menu-toggle'),dialog=document.querySelector('.mobile-menu');if(!trigger||!dialog||trigger.dataset.bound)return;trigger.dataset.bound='true';
let destination=null;const close=()=>dialog.close();
trigger.addEventListener('click',()=>{dialog.showModal();trigger.setAttribute('aria-expanded','true');dialog.querySelector('[data-menu-close]').focus();});
dialog.querySelector('[data-menu-close]').addEventListener('click',close);
dialog.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');if(destination){destination.tabIndex=-1;destination.focus({preventScroll:true});destination=null;}else trigger.focus({preventScroll:true});});
dialog.addEventListener('click',e=>{const a=e.target.closest('a');if(!a)return;close();const url=new URL(a.href,location.href);if(url.pathname===location.pathname&&url.hash){const target=document.getElementById(decodeURIComponent(url.hash.slice(1)));if(target){e.preventDefault();history.pushState(null,'',url.hash);destination=target;target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}}});
matchMedia('(min-width:761px)').addEventListener('change',e=>{if(e.matches&&dialog.open)close();});
}init();document.addEventListener('shopify:section:load',init);})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-volt-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('volt-stories'))customElements.define('volt-stories',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal,track=this.querySelector('.volt-reviews__track'),prev=this.querySelector('[data-story-step="-1"]'),next=this.querySelector('[data-story-step="1"]');if(!track)return;const update=()=>{prev.disabled=Math.abs(track.scrollLeft)<2;next.disabled=Math.abs(track.scrollLeft)>=track.scrollWidth-track.clientWidth-2;};const move=d=>{const card=track.firstElementChild;if(!card)return;track.scrollBy({left:d*(getComputedStyle(track).direction==='rtl'?-1:1)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};this.addEventListener('click',e=>{const b=e.target.closest('[data-story-step]');if(b)move(Number(b.dataset.storyStep));},{signal});track.addEventListener('scroll',update,{passive:true,signal});track.addEventListener('keydown',e=>{if(e.target===track&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},{signal});this.observer=new ResizeObserver(update);this.observer.observe(track);update();}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-volt-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('home-volt-slides'))customElements.define('home-volt-slides',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
  this.track=this.querySelector('.hv-slide-track');this.items=[...this.track.children];this.n=this.items.length;if(!this.n)return;
  this.index=Math.max(0,this.items.findIndex(b=>b.dataset.initial==='true'));this.offset=this.n>1?1:0;
  if(this.n>1){
   for(const [item,before] of [[this.items[this.n-1],true],[this.items[0],false]]){
    const clone=item.cloneNode(true);clone.dataset.clone='true';clone.tabIndex=-1;clone.setAttribute('aria-hidden','true');
    if(before)this.track.prepend(clone);else this.track.append(clone);
   }
  }
  this.width=this.getBoundingClientRect().width;
  this.scrollTo({left:(this.index+this.offset)*this.width,behavior:'instant'});this.sync(this.index+this.offset);
  const settle=()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.finish(),180);};
  this.addEventListener('scroll',()=>{
   if(!this.width)return;
   this.sync(Math.round(this.scrollLeft/this.width));settle();
  },{passive:true,signal});
  this.addEventListener('scrollend',()=>this.finish(),{signal});
  this.addEventListener('touchstart',()=>{this.touching=true;this.suppress=false;this.touchStart=this.scrollLeft;clearTimeout(this.timer);},{passive:true,signal});
  this.addEventListener('touchmove',()=>{this.suppress=true;},{passive:true,signal});
  const touchEnd=()=>{this.touching=false;settle();};
  this.addEventListener('touchend',touchEnd,{passive:true,signal});this.addEventListener('touchcancel',touchEnd,{passive:true,signal});
  this.addEventListener('dragstart',e=>e.preventDefault(),{signal});
  this.addEventListener('pointerdown',e=>{
   if(e.pointerType!=='mouse'||e.button!==0||this.n<2)return;
   this.suppress=false;this.mouse={id:e.pointerId,x:e.clientX,start:this.scrollLeft};
   this.classList.add('is-mouse-dragging');e.target.closest('.hv-slide')?.setPointerCapture(e.pointerId);
  },{signal});
  this.addEventListener('pointermove',e=>{
   const g=this.mouse;if(!g||g.id!==e.pointerId)return;const dx=e.clientX-g.x;
   if(Math.abs(dx)>5)this.suppress=true;
   this.scrollLeft=g.start-dx;
  },{signal});
  const mouseEnd=e=>{
   if(!this.mouse||this.mouse.id!==e.pointerId)return;
   this.mouse=null;this.classList.remove('is-mouse-dragging');
   this.move(Math.round(this.scrollLeft/this.width));
  };
  this.addEventListener('pointerup',mouseEnd,{signal});this.addEventListener('pointercancel',mouseEnd,{signal});
  this.addEventListener('lostpointercapture',mouseEnd,{signal});
  this.addEventListener('click',e=>{if(this.suppress){e.preventDefault();e.stopPropagation();this.suppress=false;}},{capture:true,signal});
  this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.step(e.key==='ArrowRight'?1:-1);}},{signal});
  this.observer=new ResizeObserver(()=>{
   const width=this.getBoundingClientRect().width;
   if(width>0&&Math.abs(width-this.width)>1){
    this.width=width;this.scrollTo({left:(this.index+this.offset)*width,behavior:'instant'});
   }
  });this.observer.observe(this);
 }
 move(position){
  this.scrollTo({left:Math.max(0,Math.min(this.n+this.offset,position))*this.width,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
 }
 finish(){
  if(this.touching||this.mouse||!this.width)return;
  const position=Math.round(this.scrollLeft/this.width);
  if(Math.abs(this.scrollLeft-position*this.width)>2)return;
  if(this.n>1&&(position===0||position===this.n+1)){
   const real=position===0?this.n:1;
   this.scrollTo({left:real*this.width,behavior:'instant'});this.sync(real);
  }else this.sync(position);
 }
 step(d){if(this.n<2)return;this.finish();this.move(Math.round(this.scrollLeft/this.width)+d);}
 select(index){this.move(index+this.offset);}
 sync(position){
  const index=((position-this.offset)%this.n+this.n)%this.n;
  const changed=this.index!==index;this.index=index;
  const root=this.closest('volt-home-shop'),buttons=[...root.querySelectorAll('[data-hv-image]')];
  buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
  const count=root.querySelector('[data-gallery-count]');if(count)count.textContent=(index+1)+' / '+this.n;
  [...this.track.children].forEach((button,i)=>{
   button.tabIndex=i===position?0:-1;button.setAttribute('aria-hidden',String(i!==position));
   if(Math.abs(i-position)<=2)button.querySelector('img').loading='eager';
  });
  if(changed){
   const strip=root.querySelector('.hv-thumbs'),thumb=buttons[index];
   if(strip&&thumb)strip.scrollTo({left:thumb.offsetLeft-strip.offsetLeft-strip.clientWidth/2+thumb.clientWidth/2,behavior:'instant'});
  }
 }
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();this.querySelectorAll('[data-clone]').forEach(b=>b.remove());this.ready=false;}
});

if(!customElements.get('volt-home-shop'))customElements.define('volt-home-shop',class extends HTMLElement{
connectedCallback(){
 if(this.abort)return;this.abort=new AbortController();
 try{this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);}catch{return;}
 this.select=this.querySelector('[data-variant]');this.fields=[...this.querySelectorAll('[data-option]')];
 this.querySelector('.home-volt__options').hidden=false;this.querySelector('.home-volt__fallback').hidden=true;
 this.addEventListener('change',e=>{if(e.target.matches('.home-volt__options input'))this.update();},{signal:this.abort.signal});
 this.addEventListener('click',e=>{const step=e.target.closest('[data-hv-step]'),thumb=e.target.closest('[data-hv-image]'),gallery=this.querySelector('home-volt-slides');if(step)gallery?.step(Number(step.dataset.hvStep));if(thumb)gallery?.select(Number(thumb.dataset.hvImage));},{signal:this.abort.signal});
 this.update(true);
}
update(initial=false){
 const values=this.fields.map(field=>{const value=field.querySelector('input:checked')?.value;field.querySelector('[data-selection]').textContent=value||'';return value;});
 const variant=this.variants.find(v=>v.options.every((value,index)=>value===values[index]));
 const button=this.querySelector('[type="submit"]');button.disabled=!variant?.available;button.textContent=variant?.available?this.dataset.add+' ↗':this.dataset.unavailable;
 this.select.value=variant?String(variant.id):'';
 const badge=this.querySelector('[data-hv-stock]');if(badge)badge.hidden=!variant?.available;
 if(!variant)return;
 this.querySelector('[data-price]').textContent=variant.price;
 const compare=this.querySelector('[data-compare]');compare.textContent=variant.compare;compare.hidden=!variant.compare;
 const quantity=this.querySelector('[name="quantity"]');quantity.min=variant.min;quantity.step=variant.step;if(variant.max!==null)quantity.max=variant.max;else quantity.removeAttribute('max');quantity.value=variant.min;
 const gallery=this.querySelector('home-volt-slides');if(!initial&&variant.imageId!==this.lastImageId){const slides=[...gallery.querySelectorAll('.hv-slide:not([data-clone])')],index=slides.findIndex(slide=>slide.dataset.imageId===String(variant.imageId));if(index>=0)gallery.select(index);}this.lastImageId=variant.imageId;
}
disconnectedCallback(){this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if(!customElements.get('pdp-slides'))customElements.define('pdp-slides',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
  this.track=this.querySelector('.pdp-slide-track');this.items=[...this.track.children];this.n=this.items.length;if(!this.n)return;
  this.index=Math.max(0,this.items.findIndex(b=>b.dataset.initial==='true'));this.offset=this.n>1?1:0;
  if(this.n>1){
   for(const [item,before] of [[this.items[this.n-1],true],[this.items[0],false]]){
    const clone=item.cloneNode(true);clone.dataset.clone='true';clone.tabIndex=-1;clone.setAttribute('aria-hidden','true');
    if(before)this.track.prepend(clone);else this.track.append(clone);
   }
  }
  this.width=this.getBoundingClientRect().width;
  this.scrollTo({left:(this.index+this.offset)*this.width,behavior:'instant'});this.sync(this.index+this.offset);
  const settle=()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.finish(),180);};
  this.addEventListener('scroll',()=>{
   if(!this.width)return;
   this.sync(Math.round(this.scrollLeft/this.width));settle();
  },{passive:true,signal});
  this.addEventListener('scrollend',()=>this.finish(),{signal});
  this.addEventListener('touchstart',()=>{this.touching=true;this.suppress=false;this.touchStart=this.scrollLeft;clearTimeout(this.timer);},{passive:true,signal});
  this.addEventListener('touchmove',()=>{this.suppress=true;},{passive:true,signal});
  const touchEnd=()=>{this.touching=false;settle();};
  this.addEventListener('touchend',touchEnd,{passive:true,signal});this.addEventListener('touchcancel',touchEnd,{passive:true,signal});
  this.addEventListener('dragstart',e=>e.preventDefault(),{signal});
  this.addEventListener('pointerdown',e=>{
   if(e.pointerType!=='mouse'||e.button!==0||this.n<2)return;
   this.suppress=false;this.mouse={id:e.pointerId,x:e.clientX,start:this.scrollLeft};
   this.classList.add('is-mouse-dragging');e.target.closest('.pdp-enlarge')?.setPointerCapture(e.pointerId);
  },{signal});
  this.addEventListener('pointermove',e=>{
   const g=this.mouse;if(!g||g.id!==e.pointerId)return;const dx=e.clientX-g.x;
   if(Math.abs(dx)>5)this.suppress=true;
   this.scrollLeft=g.start-dx;
  },{signal});
  const mouseEnd=e=>{
   if(!this.mouse||this.mouse.id!==e.pointerId)return;
   this.mouse=null;this.classList.remove('is-mouse-dragging');
   this.move(Math.round(this.scrollLeft/this.width));
  };
  this.addEventListener('pointerup',mouseEnd,{signal});this.addEventListener('pointercancel',mouseEnd,{signal});
  this.addEventListener('lostpointercapture',mouseEnd,{signal});
  this.addEventListener('click',e=>{if(this.suppress){e.preventDefault();e.stopPropagation();this.suppress=false;}},{capture:true,signal});
  this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.step(e.key==='ArrowRight'?1:-1);}},{signal});
  this.observer=new ResizeObserver(()=>{
   const width=this.getBoundingClientRect().width;
   if(width>0&&Math.abs(width-this.width)>1){
    this.width=width;this.scrollTo({left:(this.index+this.offset)*width,behavior:'instant'});
   }
  });this.observer.observe(this);
 }
 move(position){
  this.scrollTo({left:Math.max(0,Math.min(this.n+this.offset,position))*this.width,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
 }
 finish(){
  if(this.touching||this.mouse||!this.width)return;
  const position=Math.round(this.scrollLeft/this.width);
  if(Math.abs(this.scrollLeft-position*this.width)>2)return;
  if(this.n>1&&(position===0||position===this.n+1)){
   const real=position===0?this.n:1;
   this.scrollTo({left:real*this.width,behavior:'instant'});this.sync(real);
  }else this.sync(position);
 }
 step(d){if(this.n<2)return;this.finish();this.move(Math.round(this.scrollLeft/this.width)+d);}
 select(index){this.move(index+this.offset);}
 sync(position){
  const index=((position-this.offset)%this.n+this.n)%this.n;
  const changed=this.index!==index;this.index=index;
  const root=this.closest('[data-pdp]'),buttons=[...root.querySelectorAll('[data-image]')];
  buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
  const count=root.querySelector('[data-gallery-count]');if(count)count.textContent=(index+1)+' / '+this.n;
  [...this.track.children].forEach((button,i)=>{
   button.tabIndex=i===position?0:-1;button.setAttribute('aria-hidden',String(i!==position));
   if(Math.abs(i-position)<=2)button.querySelector('img').loading='eager';
  });
  if(changed){
   const strip=root.querySelector('.pdp-thumbs'),thumb=buttons[index];
   if(strip&&thumb)strip.scrollTo({left:thumb.offsetLeft-strip.offsetLeft-strip.clientWidth/2+thumb.clientWidth/2,behavior:'instant'});
  }
 }
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();this.querySelectorAll('[data-clone]').forEach(b=>b.remove());this.ready=false;}
});


if(!window.pdpBound){window.pdpBound=true;
document.addEventListener('click',async e=>{
const root=e.target.closest('[data-pdp]');if(!root)return;
const status=root.querySelector('[data-status]');
const step=e.target.closest('[data-gallery-step]');if(step){pdpStep(root,Number(step.dataset.galleryStep));return;}
const imageButton=e.target.closest('[data-image]');
if(imageButton){pdpSelect(root,[...root.querySelectorAll('[data-image]')].indexOf(imageButton));return;}
if(e.target.closest('[data-zoom]')){const dialog=root.querySelector('dialog');dialog.querySelector('img').src=e.target.closest('[data-zoom]').dataset.full;dialog.querySelector('img').removeAttribute('srcset');dialog.showModal();return;}
if(e.target.closest('[data-close]')){root.querySelector('dialog').close();return;}
const save=e.target.closest('[data-save]');if(save){try{const key='saved-product-'+save.dataset.key;const on=localStorage.getItem(key)!=='true';localStorage.setItem(key,String(on));save.setAttribute('aria-pressed',String(on));status.textContent=on?status.dataset.saved:status.dataset.unsaved;}catch{status.textContent=status.dataset.failed;}return;}
if(e.target.closest('[data-share]')){try{const url=new URL(location.href);url.searchParams.delete('preview_theme_id');if(navigator.share)await navigator.share({title:document.title,url:url.href});else{await navigator.clipboard.writeText(url.href);status.textContent=status.dataset.copied;}}catch(err){if(err.name!=='AbortError')status.textContent=status.dataset.failed;}return;}
const option=e.target.closest('[data-option]');if(!option||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
e.preventDefault();if(root.dataset.loading==='true')return;root.dataset.loading='true';root.querySelector('.pdp-panel').setAttribute('aria-busy','true');root.querySelector('[type=submit]').disabled=true;
const url=new URL(option.href);const request=new URL(url);request.searchParams.set('section_id',root.dataset.section);
try{const response=await fetch(request);if(!response.ok)throw Error();const html=await response.text();const next=new DOMParser().parseFromString(html,'text/html').querySelector('[data-pdp]');if(!next)throw Error();const qty=root.querySelector('[name=quantity]').value;const position=option.dataset.focus;root.replaceWith(next);const input=next.querySelector('[name=quantity]');if(Number(qty)>=Number(input.min)&&(!input.max||Number(qty)<=Number(input.max)))input.value=qty;history.replaceState({},'',url);next.querySelector('[data-focus="'+position+'"]')?.focus({preventScroll:true});restorePdpSaves(next);}catch{location.assign(url.href);}
});
function pdpCount(root){const buttons=[...root.querySelectorAll('[data-image]')];const count=root.querySelector('[data-gallery-count]');if(count)count.textContent=(Math.max(0,buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true'))+1)+' / '+buttons.length;}
function pdpSelect(root,index){root.querySelector('pdp-slides')?.select(index);}
function pdpStep(root,direction){root.querySelector('pdp-slides')?.step(direction);}
function pdpWarm(){}
function restorePdpSaves(scope){if(scope.matches?.('[data-pdp]')){pdpCount(scope);pdpWarm(scope);}scope.querySelectorAll('[data-pdp]').forEach(root=>{pdpCount(root);pdpWarm(root);});scope.querySelectorAll('[data-save]').forEach(b=>{try{b.setAttribute('aria-pressed',String(localStorage.getItem('saved-product-'+b.dataset.key)==='true'));}catch{}});}
restorePdpSaves(document);document.addEventListener('shopify:section:load',e=>restorePdpSaves(e.target));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pdp-carousel'))customElements.define('pdp-carousel',class extends HTMLElement{
 connectedCallback(){
  const track=this.querySelector('.pdp-related-grid'),prev=this.querySelector('[data-pdp-prev]'),next=this.querySelector('[data-pdp-next]');
  if(!track)return;
  const rtl=getComputedStyle(track).direction==='rtl';
  const update=()=>{prev.disabled=Math.abs(track.scrollLeft)<2;next.disabled=Math.abs(track.scrollLeft)>=track.scrollWidth-track.clientWidth-2;};
  const move=d=>{const card=track.firstElementChild;track.scrollBy({left:d*(rtl?-1:1)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
  prev.onclick=()=>move(-1);next.onclick=()=>move(1);
  const key=e=>{if(e.target!==track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move((e.key==='ArrowRight'?1:-1)*(rtl?-1:1));}};
  track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',key);
  const observer=new ResizeObserver(update);observer.observe(track);update();
  this.cleanup=()=>{observer.disconnect();track.removeEventListener('scroll',update);track.removeEventListener('keydown',key);prev.onclick=null;next.onclick=null;};
 }
 disconnectedCallback(){this.cleanup?.();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-perspective"] && !Shopify.designMode) return;
  try {
    
(() => {
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
document.querySelectorAll('.perspective').forEach(section=>{const frames=[...section.querySelectorAll('.perspective-frame')],chapters=[...section.querySelectorAll('.chapter')],buttons=[...section.querySelectorAll('.chapter-dots button')],visual=section.querySelector('.perspective-visual');let active=0,lastScroll=scrollY,manual=false,down=null;
const show=i=>{active=(i+frames.length)%frames.length;frames.forEach((f,j)=>{f.classList.toggle('active',j===active);f.setAttribute('aria-hidden',j!==active);});chapters.forEach((c,j)=>{c.classList.toggle('active',j===active);c.setAttribute('aria-hidden',j!==active);});buttons.forEach((b,j)=>b.setAttribute('aria-pressed',j===active));};
buttons.forEach((b,i)=>b.onclick=()=>{manual=true;lastScroll=scrollY;show(i);});visual.addEventListener('pointerdown',e=>{down=e.clientX;});visual.addEventListener('pointerup',e=>{if(down!==null&&Math.abs(e.clientX-down)>35){manual=true;lastScroll=scrollY;show(active+(e.clientX<down?1:-1));}down=null;});visual.addEventListener('pointercancel',()=>down=null);visual.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();manual=true;lastScroll=scrollY;show(active+(e.key==='ArrowRight'?1:-1));}});
let queued=false;const update=()=>{const r=section.getBoundingClientRect(),travel=Math.max(1,section.offsetHeight-innerHeight);const p=Math.max(0,Math.min(1,-r.top/travel));section.querySelector('.chapter-progress i').style.width=`${p*100}%`;const phase=(p*frames.length)%1;const push=Math.sin(phase*Math.PI);visual.style.setProperty('--camera-scale',String(1+push*.65));visual.style.setProperty('--camera-y',`${push*45}px`);visual.style.setProperty('--camera-x',`${Math.sin(p*Math.PI*2)*-18}px`);if(Math.abs(scrollY-lastScroll)>80)manual=false;if(!manual&&r.top<100&&r.bottom>0)show(Math.min(frames.length-1,Math.floor(p*frames.length)));queued=false;};if(!reduce)addEventListener('scroll',()=>{if(!queued){requestAnimationFrame(update);queued=true;}},{passive:true});show(0);
});
const stage=document.querySelector('.hero-stage');if(stage){const button=document.createElement('button');button.className='zoom-button';button.textContent='+';button.setAttribute('aria-label','Zoom jacket photo');stage.append(button);const dialog=document.createElement('dialog');dialog.className='zoom-dialog';dialog.setAttribute('aria-label','Jacket image zoom');dialog.innerHTML='<button class="close" aria-label="Close zoom">×</button><img alt="">';document.body.append(dialog);button.onclick=()=>{const source=stage.querySelector('img'),img=dialog.querySelector('img');img.src=source.src;img.alt=source.alt;dialog.classList.remove('zoomed');dialog.showModal();};dialog.querySelector('.close').onclick=()=>dialog.close();dialog.querySelector('img').onclick=()=>dialog.classList.toggle('zoomed');dialog.querySelector('img').onpointermove=e=>{if(e.pointerType==='touch')return;const r=e.currentTarget.getBoundingClientRect();dialog.style.setProperty('--zoom-x',`${(e.clientX-r.left)/r.width*100}%`);dialog.style.setProperty('--zoom-y',`${(e.clientY-r.top)/r.height*100}%`);};}
if(reduce)return;
const progress=document.createElement('div');progress.className='page-progress';document.body.append(progress);let pending=false;addEventListener('scroll',()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{progress.style.width=`${scrollY/Math.max(1,document.documentElement.scrollHeight-innerHeight)*100}%`;pending=false;});},{passive:true});
if(matchMedia('(pointer:fine)').matches)document.querySelectorAll('.pill').forEach(button=>{button.onpointermove=e=>{const r=button.getBoundingClientRect();button.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.12}px,${(e.clientY-r.top-r.height/2)*.22}px)`;};button.onpointerleave=()=>button.style.transform='';});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--announcement-bar"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-announcement-bar-section')){
  class StackAnnouncementBarSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.blocks = null;
      this.autoRotate = false;
      this.displayDuration = 5000;
      this.currentIndex = 0;
      this.rotationInterval = null;
      this.countdownIntervals = [];
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack){
        setTimeout(()=>{
          if(!window.stack){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      this.blocks = this.querySelectorAll('.stack--announcement-bar-block');
      if (this.blocks.length <= 1) return;

      this.autoRotate = this.dataset.autoRotate === 'true';
      this.displayDuration = parseInt(this.dataset.displayDuration) || 5000;

      this.initCountdownTimers();
      this.initCopyButtons();
      this.initNavigation();
      this.initHoverControls();
      this.startRotation();

      this.initialized = true;
    }

    showBlock(index) {
      this.blocks.forEach((block, i) => {
        block.classList.toggle('stack--announcement-bar-active', i === index);
      });
      this.currentIndex = index;
    }

    nextBlock() {
      const nextIndex = (this.currentIndex + 1) % this.blocks.length;
      this.showBlock(nextIndex);
    }

    prevBlock() {
      const prevIndex = this.currentIndex === 0 ? this.blocks.length - 1 : this.currentIndex - 1;
      this.showBlock(prevIndex);
    }

    startRotation() {
      this.stopRotation();
      if (this.autoRotate) {
        this.rotationInterval = setInterval(() => {
          this.nextBlock();
        }, this.displayDuration);
      }
    }

    stopRotation() {
      if (this.rotationInterval) {
        clearInterval(this.rotationInterval);
        this.rotationInterval = null;
      }
    }

    initNavigation() {
      const nextBtn = this.querySelector('.stack--announcement-bar-next');
      const prevBtn = this.querySelector('.stack--announcement-bar-prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          this.stopRotation();
          this.nextBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          this.stopRotation();
          this.prevBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }
    }

    initHoverControls() {
      this.addEventListener('mouseenter', () => this.stopRotation());
      this.addEventListener('mouseleave', () => this.startRotation());
    }

    initCountdownTimers() {
      const countdownElements = this.querySelectorAll('.stack--announcement-bar-time[data-target-date]');

      countdownElements.forEach(element => {
        const targetDate = new Date(element.dataset.targetDate);

        const updateCountdown = () => {
          const now = new Date().getTime();
          const distance = targetDate.getTime() - now;

          if (distance < 0) {
            element.querySelector('.stack--announcement-bar-countdown').innerHTML = '0:00:00';
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const daysEl = element.querySelector('.stack--announcement-bar-days');
          const daysSeparatorEl = element.querySelector('.stack--announcement-bar-days-separator');
          const hoursEl = element.querySelector('.stack--announcement-bar-hours');
          const minutesEl = element.querySelector('.stack--announcement-bar-minutes');
          const secondsEl = element.querySelector('.stack--announcement-bar-seconds');

          // Show/hide days based on whether there are any
          if (daysEl && daysSeparatorEl) {
            if (days > 0) {
              daysEl.style.display = 'inline';
              daysSeparatorEl.style.display = 'inline';
              daysEl.textContent = days;
            } else {
              daysEl.style.display = 'none';
              daysSeparatorEl.style.display = 'none';
            }
          }

          if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
          if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
          if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
        };

        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);
        this.countdownIntervals.push(intervalId);
      });
    }

    initCopyButtons() {
      const discountWrappers = this.querySelectorAll('.stack--announcement-bar-discount-wrapper');

      discountWrappers.forEach(wrapper => {
        const copyButton = wrapper.querySelector('.stack--announcement-bar-copy-btn');

        if (copyButton) {
          const code = copyButton.dataset.code;
          wrapper.style.cursor = 'pointer';

          const copyToClipboard = () => {
            if (navigator.clipboard) {
              navigator.clipboard.writeText(code).then(() => {
                this.showCopyFeedback(copyButton);
              }).catch(() => {
                this.fallbackCopy(code, copyButton);
              });
            } else {
              this.fallbackCopy(code, copyButton);
            }
          };

          copyButton.addEventListener('click', (e) => {
            e.stopPropagation();
            copyToClipboard();
          });

          wrapper.addEventListener('click', (e) => {
            if (e.target !== copyButton) {
              copyToClipboard();
            }
          });
        }
      });
    }

    fallbackCopy(code, button) {
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.showCopyFeedback(button);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    }

    showCopyFeedback(button) {
      const originalHTML = button.innerHTML;

      button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.classList.add('copied');

      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.classList.remove('copied');
      }, 2000);
    }

    disconnectedCallback() {
      this.stopRotation();
      this.countdownIntervals.forEach(intervalId => clearInterval(intervalId));
      this.countdownIntervals = [];
      this.initialized = false;
    }
  }

  customElements.define('stack-announcement-bar-section', StackAnnouncementBarSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      section.init();
    }
  }
});

document.addEventListener('shopify:section:deselect', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      const blocks = section.querySelectorAll('.stack--announcement-bar-block');
      blocks.forEach(block => {
        block.style.animation = 'none';
      });
    }
  }
});

document.addEventListener('shopify:theme:section:reorder', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--before-after"] && !Shopify.designMode) return;
  try {
    
(async()=>{
  if(!customElements.get('stack-before-after-slider')){
    class StackBeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        if(!window.stack) {
          setTimeout(() => { if(!window.stack) this.remove(); else this.init(); }, 100);
          return;
        }
        this.init();
      }
      
      init() {
        if(this.initialized) return;
        this.initialized = true;
        
        this.container = this.querySelector('.stack--comparison-container');
        this.beforeImage = this.querySelector('[data-before-image]');
        this.divider = this.querySelector('[data-divider]');
        this.handle = this.querySelector('[data-handle]');
        
        if(!this.container || !this.beforeImage || !this.divider || !this.handle) return;
        
        this.position = parseInt(this.dataset.initial) || 50;
        this.isDragging = false;
        
        this.updatePosition(this.position);
        
        // Mouse events
        this.handle.addEventListener('mousedown', this.startDrag.bind(this));
        document.addEventListener('mousemove', this.onDrag.bind(this));
        document.addEventListener('mouseup', this.stopDrag.bind(this));
        
        // Touch events
        this.container.addEventListener('touchstart', this.startDrag.bind(this), {passive: true});
        document.addEventListener('touchmove', this.onTouchMove.bind(this), {passive: false});
        document.addEventListener('touchend', this.stopDrag.bind(this));
        
        // Keyboard events
        this.handle.addEventListener('keydown', this.onKey.bind(this));
      }
      
      updatePosition(percent) {
        percent = Math.max(0, Math.min(100, percent));
        this.position = percent;
        this.beforeImage.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
        this.divider.style.left = `${percent}%`;
        this.handle.style.left = `${percent}%`;
        this.handle.setAttribute('aria-valuenow', percent);
      }
      
      getPositionFromEvent(e) {
        const rect = this.container.getBoundingClientRect();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        return ((clientX - rect.left) / rect.width) * 100;
      }
      
      startDrag(e) {
        if(e.type === 'mousedown') e.preventDefault();
        this.isDragging = true;
        this.container.classList.add('is-dragging');
      }
      
      onDrag(e) {
        if(!this.isDragging) return;
        this.updatePosition(this.getPositionFromEvent(e));
      }
      
      onTouchMove(e) {
        if(!this.isDragging) return;
        // Check if movement is mostly horizontal
        if (e.touches && e.touches.length) {
           this.updatePosition(this.getPositionFromEvent(e));
           e.preventDefault(); // Prevent scrolling while dragging slider
        }
      }
      
      stopDrag() {
        this.isDragging = false;
        this.container.classList.remove('is-dragging');
      }
      
      onKey(e) {
        if(!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        if(e.key === 'ArrowLeft') this.updatePosition(this.position - 5);
        if(e.key === 'ArrowRight') this.updatePosition(this.position + 5);
        if(e.key === 'Home') this.updatePosition(0);
        if(e.key === 'End') this.updatePosition(100);
      }
    }
    customElements.define('stack-before-after-slider', StackBeforeAfterSlider);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--faq"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-faq-section')){
  class StackFAQSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.resizeTimeout = null;
      this.boundResize = this.onResize.bind(this);
    }

    connectedCallback() {
      if(!window.stack){
        setTimeout(() => { if(window.stack) this.init(); else this.remove(); }, 100);
      } else {
        requestAnimationFrame(() => this.init());
      }
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;

      const questions = this.querySelectorAll('.stack--faq-question');
      this.setHeights();

      window.addEventListener('resize', this.boundResize);

      questions.forEach(q => {
        q.addEventListener('click', this.onClick.bind(this));
      });
    }

    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.setHeights(), 200);
    }

    setHeights() {
      const answers = this.querySelectorAll('.stack--faq-answer');
      answers.forEach(ans => {
        const inner = ans.querySelector('.stack--faq-answer-inner');
        if(!inner) return;
        ans.style.height = (ans.getAttribute('aria-hidden') === 'false') ? inner.offsetHeight + 'px' : '0px';
      });
    }

    onClick(e) {
      const btn = e.currentTarget;
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      const targetId = btn.getAttribute('aria-controls');
      const target = document.getElementById(targetId);

      if(!target) return;
      const inner = target.querySelector('.stack--faq-answer-inner');
      if(!inner) return;

      if(isExpanded) {
        btn.setAttribute('aria-expanded', 'false');
        target.setAttribute('aria-hidden', 'true');
        target.style.height = '0px';
      } else {
        btn.setAttribute('aria-expanded', 'true');
        target.setAttribute('aria-hidden', 'false');
        target.style.height = inner.offsetHeight + 'px';

        // Close others (Accordion)
        const allBtns = this.querySelectorAll('.stack--faq-question');
        allBtns.forEach(otherBtn => {
          if(otherBtn !== btn && otherBtn.getAttribute('aria-expanded') === 'true') {
            otherBtn.setAttribute('aria-expanded', 'false');
            const otherTarget = document.getElementById(otherBtn.getAttribute('aria-controls'));
            if(otherTarget) {
              otherTarget.setAttribute('aria-hidden', 'true');
              otherTarget.style.height = '0px';
            }
          }
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundResize);
    }
  }
  customElements.define('stack-faq-section', StackFAQSection);
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--image-with-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--image-with-benefits');
if(!el)return;
if(!window.stack){setTimeout(()=>{if(!window.stack){el.remove()}},100);return;}
if(!window.stack){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--logo-slider"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-logo-slider-section')){
  class StackLogoSliderSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.resizeTimeout = null;
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack){
        setTimeout(()=>{
          if(!window.stack){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const marquee = this.querySelector('.stack--logo-slider-marquee');
      const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
      
      if (!marquee || !tracksContainer) return;
      
      if (window.getComputedStyle(document.documentElement).getPropertyValue('direction') === 'rtl') {
        marquee.classList.add('stack--logo-slider-rtl');
      }
      
      this.adjustTrackCount(tracksContainer);
      
      // Setup resize listener
      window.addEventListener('resize', this.boundHandleResize);
      
      this.initialized = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
        if (tracksContainer) {
          this.adjustTrackCount(tracksContainer);
        }
      }, 250);
    }

    adjustTrackCount(tracksContainer) {
      const existingTracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      const firstTrack = existingTracks[0];
      
      if (!firstTrack) return;
      
      const screenWidth = window.innerWidth;
      const trackWidth = firstTrack.scrollWidth;
      const neededTracks = Math.max(3, Math.ceil((screenWidth * 2) / trackWidth));
      const currentTracks = existingTracks.length;
      
      if (neededTracks > currentTracks) {
        for (let i = currentTracks; i < neededTracks; i++) {
          const newTrack = firstTrack.cloneNode(true);
          newTrack.setAttribute('aria-hidden', 'true');
          
          newTrack.querySelectorAll('.stack--logo-slider-item').forEach(item => {
            item.removeAttribute('data-block-id');
            item.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
            item.querySelectorAll('img').forEach(img => img.setAttribute('alt', ''));
          });
          
          tracksContainer.appendChild(newTrack);
        }
        this.resetAnimation(tracksContainer);
      }
      
      if (neededTracks < currentTracks) {
        for (let i = currentTracks - 1; i >= neededTracks; i--) {
          if (existingTracks[i] && i > 0) {
            existingTracks[i].remove();
          }
        }
        this.resetAnimation(tracksContainer);
      }
    }

    resetAnimation(tracksContainer) {
      const tracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      tracks.forEach(track => {
        track.style.animation = 'none';
        track.offsetHeight;
        track.style.animation = null;
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.initialized = false;
    }
  }

  customElements.define('stack-logo-slider-section', StackLogoSliderSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        section.disconnectedCallback();
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--product"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-product-section')){
  class StackProductSection extends HTMLElement {
    connectedCallback() {
      if(!window.stack){
        setTimeout(()=>{ if(!window.stack){ this.remove(); } else { this.init(); } },100);
        return;
      }
      this.init();
    }
    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.timers = [];
      this.initLiveViewers();
      this.initDeliveryDates();
      this.initSizeCharts();
    }
    initLiveViewers() {
      this.querySelectorAll('.stack--live-viewers').forEach(el => {
        const min = parseInt(el.dataset.min, 10) || 30;
        const max = parseInt(el.dataset.max, 10) || 60;
        const count = el.querySelector('[data-viewer-count]');
        if (!count) return;
        let v = Math.floor(Math.random() * (max - min + 1)) + min;
        count.textContent = v;
        const tick = () => {
          v += (Math.floor(Math.random() * 3) + 1) * (Math.random() > 0.5 ? 1 : -1);
          v = Math.min(max, Math.max(min, v));
          count.textContent = v;
          const t = setTimeout(tick, Math.floor(Math.random() * 3000) + 5000);
          this.timers.push(t);
        };
        const t = setTimeout(tick, Math.floor(Math.random() * 3000) + 5000);
        this.timers.push(t);
      });
    }
    initDeliveryDates() {
      this.querySelectorAll('[data-delivery-date]').forEach(el => {
        try {
          const ts = parseInt(el.dataset.timestamp, 10) * 1000;
          const locale = el.dataset.locale || 'en';
          el.textContent = new Intl.DateTimeFormat(locale, { weekday: 'long', month: 'short', day: 'numeric' }).format(new Date(ts));
        } catch (e) {}
      });
    }
    initSizeCharts() {
      this.onKey = (e) => { if (e.key === 'Escape') this.closeCharts(); };
      this.querySelectorAll('.stack--size-chart').forEach(wrap => {
        const popup = wrap.querySelector('[data-size-chart-popup]');
        if (popup && popup.parentNode !== document.body) document.body.appendChild(popup);
        wrap.querySelectorAll('[data-size-chart-open]').forEach(b => b.addEventListener('click', () => this.openChart(popup)));
        if (popup) popup.querySelectorAll('[data-size-chart-close]').forEach(b => b.addEventListener('click', () => this.closeCharts()));
        wrap._popup = popup;
      });
    }
    openChart(popup) {
      if (!popup) return;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
    }
    closeCharts() {
      this.querySelectorAll('.stack--size-chart').forEach(w => { if (w._popup) w._popup.hidden = true; });
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
    }
    disconnectedCallback() {
      (this.timers || []).forEach(t => clearTimeout(t));
      document.removeEventListener('keydown', this.onKey);
      this.querySelectorAll('.stack--size-chart').forEach(w => { if (w._popup && w._popup.parentNode === document.body) w._popup.remove(); });
    }
  }
  customElements.define('stack-product-section', StackProductSection);
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--related-products"] && !Shopify.designMode) return;
  try {
    
(async () => {
  if (!customElements.get('stack-related-products')) {
    class StackRelatedProducts extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
      }

      connectedCallback() {
        if (!window.stack) {
          setTimeout(() => { if (window.stack) this.init(); else this.remove(); }, 100);
        } else {
          requestAnimationFrame(() => this.init());
        }
      }

      async init() {
        if (this.initialized) return;
        this.initialized = true;

        const productId = this.getAttribute('data-product-id');
        const limit = this.getAttribute('data-limit') || 4;
        const grid = this.querySelector('.stack--rp-grid');

        if (!productId || !grid) return;

        // Render Skeletons
        grid.innerHTML = Array.from({ length: limit }).map(() => `
          <div class="stack--rp-skeleton-card">
            <div class="stack--rp-image-wrapper"></div>
            <div class="stack--rp-info">
              <div class="stack--rp-skeleton-title"></div>
              <div class="stack--rp-skeleton-price"></div>
            </div>
          </div>
        `).join('');

        try {
          const response = await fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}`);
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.json();
          const products = data.products;

          if (products && products.length > 0) {
            grid.innerHTML = products.map(product => this.renderProductCard(product)).join('');
          } else {
            // Hide section if no recommendations
            this.style.display = 'none';
          }
        } catch (error) {
          console.error('Error fetching related products:', error);
          this.style.display = 'none';
        }
      }

      renderProductCard(product) {
        const image = product.featured_image ? product.featured_image : '';
        const hoverImage = product.images.length > 1 ? product.images[1] : image;
        
        // Format money (basic formatter since we don't have liquid filter here)
        const formatMoney = (cents) => {
          return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify.currency.active });
        };

        const price = formatMoney(product.price);
        const comparePrice = product.compare_at_price > product.price ? formatMoney(product.compare_at_price) : null;

        return `
          <a href="${product.url}" class="stack--rp-card">
            <div class="stack--rp-image-wrapper">
              ${image ? `<img src="${image}" alt="${product.title}" class="stack--rp-image" loading="lazy">` : ''}
              ${hoverImage && hoverImage !== image ? `<img src="${hoverImage}" alt="${product.title}" class="stack--rp-image stack--rp-image-hover" loading="lazy">` : ''}
            </div>
            <div class="stack--rp-info">
              <h3 class="stack--rp-title">${product.title}</h3>
              <div class="stack--rp-price">
                ${comparePrice ? `<span class="stack--rp-price-compare">${comparePrice}</span>` : ''}
                <span>${price}</span>
              </div>
            </div>
          </a>
        `;
      }
    }
    customElements.define('stack-related-products', StackRelatedProducts);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--shoppable-slides"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-shoppable-slides-section')){
class StackShoppableSlidesSection extends HTMLElement {
constructor() {
super();
this.initialized = false;
this.swiper = null;
this.currentlyPlayingVideo = null;
}

connectedCallback() {
if(!window.stack){
setTimeout(()=>{
 if(!window.stack){
   this.remove();
 } else {
   this.init();
 }
},100);
return;
}
requestAnimationFrame(() => this.init());
}

init() {
if (this.initialized) return;

// Add initial load class for animation
if (this.classList.contains('stack--shoppable-slides-fade')) {
this.classList.add('stack--shoppable-slides-initial-load');
// Remove after animation completes
setTimeout(() => {
 this.classList.remove('stack--shoppable-slides-initial-load');
}, 1500);
}

this.initSwiperSlider();
this.initVideoControls();

this.initialized = true;
}

initSwiperSlider() {
const swiperContainer = this.querySelector('.stack--shoppable-slides-swiper');
if (!swiperContainer) return;

// Wait for Swiper library to load
if (typeof Swiper === 'undefined') {
setTimeout(() => this.initSwiperSlider(), 100);
return;
}

const autoplayEnabled = this.dataset.autoplay === 'true';
const coverflowEnabled = this.dataset.coverflow === 'true';
const swiperId = swiperContainer.id;

// Initialize Swiper configuration
const swiperConfig = {
grabCursor: true,
centeredSlides: true,
slidesPerView: 'auto',
spaceBetween: 20,
loop: true,
loopAddBlankSlides: true,
loopAdditionalSlides: 3,
speed: 600,

// Navigation (scoped to this specific swiper)
navigation: {
 nextEl: this.querySelector('.swiper-button-next'),
 prevEl: this.querySelector('.swiper-button-prev'),
},

// Autoplay (optional)
...(autoplayEnabled && {
 autoplay: {
   delay: 5000,
   disableOnInteraction: false,
   pauseOnMouseEnter: true,
 },
}),

// Coverflow effect (optional)
...(coverflowEnabled && {
 effect: 'coverflow',
 coverflowEffect: {
   rotate: 0,
   stretch: 0,
   depth: 85,
   modifier: 1,
   slideShadows: true,
 },
}),

// Accessibility
a11y: {
 enabled: true,
 prevSlideMessage: 'Previous video',
 nextSlideMessage: 'Next video',
 firstSlideMessage: 'This is the first video',
 lastSlideMessage: 'This is the last video',
},

// Keyboard control
keyboard: {
 enabled: true,
 onlyInViewport: true,
},

// Responsive breakpoints
breakpoints: {
 1024: {
   spaceBetween: 50,
 },
 768: {
  spaceBetween: 40,
 }
},

// Prevent animation on init
runCallbacksOnInit: false,

// On slide change, stop all videos
on: {
 slideChange: () => {
   this.stopAllVideos();
 },
},
};

// Initialize Swiper with unique ID
this.swiper = new Swiper(`#${swiperId}`, swiperConfig);
}

initVideoControls() {
const slides = this.querySelectorAll('.swiper-slide');

slides.forEach((slide) => {
 const video = slide.querySelector('.stack--shoppable-slides-video');
 const playButton = slide.querySelector('.stack--shoppable-slides-play-button');
 const playIcon = slide.querySelector('#iconPlay');
 const pauseIcon = slide.querySelector('#iconPause');

 if (!video || !playButton || !playIcon || !pauseIcon) return;

 // Play/Pause on button click
 playButton.addEventListener('click', (e) => {
   e.stopPropagation();
   
   // Only allow interaction on active, prev, or next slides
   if (
     slide.classList.contains('swiper-slide-active') ||
     slide.classList.contains('swiper-slide-next') ||
     slide.classList.contains('swiper-slide-prev')
   ) {
     // Stop other videos first
     if (this.currentlyPlayingVideo && this.currentlyPlayingVideo !== video) {
       this.stopVideo(this.currentlyPlayingVideo);
     }

     // Toggle current video
     if (video.paused) {
       video.volume = 0.4;
       video.play();
       playIcon.style.display = 'none';
       pauseIcon.style.display = 'block';
       playButton.setAttribute('aria-label', 'Pause video');
       this.currentlyPlayingVideo = video;
     } else {
       this.stopVideo(video);
     }
   }
 });

 // Reset video when it ends
 video.addEventListener('ended', () => {
   video.currentTime = 0;
   playIcon.style.display = 'block';
   pauseIcon.style.display = 'none';
   playButton.setAttribute('aria-label', 'Play video');
   if (this.currentlyPlayingVideo === video) {
     this.currentlyPlayingVideo = null;
   }
 });
});
}

stopVideo(video) {
if (!video) return;

const slide = video.closest('.swiper-slide');
if (!slide) return;

const playIcon = slide.querySelector('#iconPlay');
const pauseIcon = slide.querySelector('#iconPause');
const playButton = slide.querySelector('.stack--shoppable-slides-play-button');

video.pause();
if (playIcon) playIcon.style.display = 'block';
if (pauseIcon) pauseIcon.style.display = 'none';
if (playButton) playButton.setAttribute('aria-label', 'Play video');

if (this.currentlyPlayingVideo === video) {
 this.currentlyPlayingVideo = null;
}
}

stopAllVideos() {
const videos = this.querySelectorAll('.stack--shoppable-slides-video');
videos.forEach(video => this.stopVideo(video));
}

disconnectedCallback() {
// Cleanup Swiper instance
if (this.swiper && this.swiper.destroy) {
this.swiper.destroy(true, true);
}
this.stopAllVideos();
this.initialized = false;
}
}

customElements.define('stack-shoppable-slides-section', StackShoppableSlidesSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
setTimeout(() => section.init(), 100);
}
}
});

document.addEventListener('shopify:section:select', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
section.init();
}
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--stats-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-stats-benefits-section')){
  class StackStatsBenefitsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.observer = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack){
        setTimeout(()=>{
          if(!window.stack){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const counters = this.querySelectorAll('.stack--stats-benefits-counter');
      const observerOptions = {
        threshold: 0.5,
        rootMargin: '0px 0px -50px 0px'
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.dataset.animated) {
            this.animateCounter(entry.target);
            entry.target.dataset.animated = 'true';
          }
        });
      }, observerOptions);

      counters.forEach(counter => {
        this.observer.observe(counter);
      });

      this.initialized = true;
    }

    animateCounter(counter) {
      const from = parseInt(counter.dataset.from) || 0;
      const to = parseInt(counter.dataset.to) || 0;
      const duration = parseInt(counter.dataset.duration) || 2000;
      
      if (from === to) return;
      
      const startTime = performance.now();
      const difference = to - from;
      
      const updateCounter = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(from + (difference * easeOut));
        
        counter.textContent = currentValue;
        
        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = to;
        }
      };
      
      requestAnimationFrame(updateCounter);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-stats-benefits-section', StackStatsBenefitsSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--stats-benefits')) {
      const section = document.querySelector('.stack--stats-benefits');
      if (section && section.tagName.toLowerCase() === 'stack-stats-benefits-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--sticky-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stack-sticky-cart')) {
  class StackStickyCart extends HTMLElement {
    constructor() {
      super();
      this.behavior = this.dataset.behavior || 'atc';
      this.button = this.querySelector('[data-action-button]');
      this.select = this.querySelector('[data-variant-select]');
      this.hasScrolled = false;
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', this.handleAction.bind(this));
      }
      
      // Simple scroll listener to show the sticky cart
      window.addEventListener('scroll', () => {
        if (window.scrollY > 400 && !this.hasScrolled) {
          this.classList.add('is-visible');
          this.hasScrolled = true;
        } else if (window.scrollY <= 400 && this.hasScrolled) {
          this.classList.remove('is-visible');
          this.hasScrolled = false;
        }
      }, { passive: true });
    }

    handleAction(e) {
      e.preventDefault();
      
      if (this.behavior === 'scrollup') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        // Add to cart behavior
        const variantId = this.select ? this.select.value : null;
        if (!variantId) return;

        // Use Shopify cart API or theme's cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.addItemToCart === 'function') {
          cartDrawer.addItemToCart(variantId);
        } else {
          // Fallback to standard fetch
          const formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      }
    }
  }
  customElements.define('stack-sticky-cart', StackStickyCart);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--story-menu"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--stories');
if(!el)return;
if(!window.stack){setTimeout(()=>{if(!window.stack){el.remove()}},100);return;}
if(!window.stack){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--video-carousel"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-video-carousel-section')){
  class StackVideoCarouselSection extends HTMLElement {
    connectedCallback() {
      if(!window.stack){
        setTimeout(()=>{ if(!window.stack){ this.remove(); } else { this.init(); } },100);
        return;
      }
      this.init();
    }
    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('.stack--video-carousel-play').forEach(btn => {
        btn.addEventListener('click', () => this.playVideo(btn.closest('.stack--video-carousel-item')));
      });
    }
    playVideo(item) {
      if (!item || item.classList.contains('is-playing')) return;
      const poster = item.querySelector('.stack--video-carousel-poster');
      const tpl = item.querySelector('.stack--video-carousel-template');
      if (!poster || !tpl) return;
      const node = tpl.content.cloneNode(true);
      poster.innerHTML = '';
      poster.appendChild(node);
      item.classList.add('is-playing');
      const video = poster.querySelector('video');
      if (video) { video.play().catch(() => {}); }
    }
  }
  customElements.define('stack-video-carousel-section', StackVideoCarouselSection);
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--video-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stack-video-testimonials')) {
  class StackVideoTestimonials extends HTMLElement {
    constructor() {
      super();
      this.videos = this.querySelectorAll('video');
      this.playBtns = this.querySelectorAll('.stack--vt-play-btn');
    }

    connectedCallback() {
      this.playBtns.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          const video = this.videos[index];
          if (video) {
            // Pause all other videos
            this.videos.forEach(v => {
              if (v !== video) {
                v.pause();
                v.classList.remove('is-playing');
              }
            });

            // Play this video
            video.classList.add('is-playing');
            video.play();
          }
        });
      });

      this.videos.forEach(video => {
        video.addEventListener('pause', () => {
          video.classList.remove('is-playing');
        });
        video.addEventListener('ended', () => {
          video.classList.remove('is-playing');
        });
      });
    }
  }
  customElements.define('stack-video-testimonials', StackVideoTestimonials);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volt-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('volt-stories'))customElements.define('volt-stories',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal,track=this.querySelector('.volt-reviews__track'),prev=this.querySelector('[data-story-step="-1"]'),next=this.querySelector('[data-story-step="1"]');if(!track)return;const update=()=>{prev.disabled=Math.abs(track.scrollLeft)<2;next.disabled=Math.abs(track.scrollLeft)>=track.scrollWidth-track.clientWidth-2;};const move=d=>{const card=track.firstElementChild;if(!card)return;track.scrollBy({left:d*(getComputedStyle(track).direction==='rtl'?-1:1)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};this.addEventListener('click',e=>{const b=e.target.closest('[data-story-step]');if(b)move(Number(b.dataset.storyStep));},{signal});track.addEventListener('scroll',update,{passive:true,signal});track.addEventListener('keydown',e=>{if(e.target===track&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},{signal});this.observer=new ResizeObserver(update);this.observer.observe(track);update();}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volt-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-volt-image]');if(!button)return;const section=button.closest('.volt-story'),image=section.querySelector('.volt-image');const src=button.dataset.voltImage;image.dataset.pending=src;const next=new Image();next.onload=()=>{if(image.dataset.pending!==src)return;image.removeAttribute('srcset');image.src=src;image.alt=button.dataset.alt;section.querySelector('.volt-caption').textContent=button.textContent.trim();section.querySelectorAll('[data-volt-image]').forEach(b=>b.setAttribute('aria-pressed',b===button));if(!matchMedia('(prefers-reduced-motion: reduce)').matches)image.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:500,easing:'ease-out'});};next.src=src;});

  } catch(e) { console.error(e); }
})();
})();
